// extracted by mini-css-extract-plugin
module.exports = {"title":"IndexPage-module--title--2P2vR","links":"IndexPage-module--links--R75iz","link":"IndexPage-module--link--1oDVt"};